import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

import { Claim } from '../../../fragments';

const CLAIM_QUERY = gql`
  query CLAIM_QUERY($id: ID!) {
    claim(id: $id) {
      ...Claim
      token
      correctedInformation
      passengerTicketId
      flightId
      codeClaim
      claimsPassengerTicketConnection {
        edges {
          node {
            passengerTicket {
              id
              pnr
              passengerFirstName
              passengerLastName
            }
          }
        }
      }
      flightsPassengerTicketsConnection {
        edges {
          cursor
          node {
            id
            flight {
              id
              airportOrigin {
                iata
              }
              airportDestination {
                iata
              }
              airline {
                iata
              }
              number
              localArrivalDate
              localDepartureDate
            }
          }
        }
      }
    }
  }
  ${Claim.fragment}
`;

const withClaimQuery = graphql(CLAIM_QUERY, {
  options: ({ task }) => ({
    variables: {
      id: task && task.claimId
    }
  }),
  props: ({ data: { claim, loading, error, refetch } }) => ({
    error,
    loading,
    claim,
    refetch
  })
});

export default withClaimQuery;



// WEBPACK FOOTER //
// ./src/component/tasks/CorrectClaimTask/withClaimQuery.js